import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { CircularProgress } from '@mui/material'

import './CampaignSelect.css'
import Icon from '../../../components/UI/Icon'

/**
 * Displays the list of campaigns a user belongs to and lets them pick one to log into
 */
const CampaignSelect = ({ campaigns, onSelect, onBack }) => {
    const { isLoading } = useSelector((state) => state.auth)

    return (
        <>
            <div className="campaign-select-form-header">
                <div className="form-title" onClick={onBack}>
                    <Icon name="arrow-left" />
                    <span className="header-2">Select your campaign</span>
                </div>

                <span className="form-subtitle text-4">
                    We’ve noticed multiple campaigns connected to your account. Select the one you want to view.
                </span>
            </div>

            <div className="campaign-select-list">
                {campaigns.map((campaign) => (
                    <div className={`campaign-select-item ${isLoading ? 'loading' : ''}`} key={`${campaign.campaignid}-${campaign.userid}`} onClick={() => onSelect(campaign)}>
                        <div className="container-content">
                            <span className="header-4">{campaign.campaignname}</span>
                            <span className="header-5">{campaign.campaigncode}</span>
                        </div>
                        {isLoading ? (
                            <CircularProgress
                                size={20}
                                thickness={4}
                                color="inherit"
                                className="c-button-spinner"
                            />
                        ) : (
                            <Icon name="arrow-right" />
                        )}
                    </div>
                ))}
            </div>
        </>
    )
}

CampaignSelect.propTypes = {
    campaigns: PropTypes.arrayOf(
        PropTypes.shape({
            campaignid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            campaigncode: PropTypes.string,
            campaignname: PropTypes.string.isRequired,
            userid: PropTypes.string.isRequired,
        })
    ).isRequired,
    onSelect: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
}

export default CampaignSelect
